import React from 'react';
import DescSortIcon from '@icons/common/chevron-down.svg';
import { IconWrapper } from './styled';

function SortIndicator({ sortOrder }) {
  return sortOrder === 'desc'
    ? (<IconWrapper><DescSortIcon /></IconWrapper>) : null;
}

export default SortIndicator;
